/** Resolve IN vs UAE from the request path (supports /in/* routes). */
function resolveCountry(path = "", req) {
  const regionHeader = req?.headers?.["x-region"];
  if (regionHeader === "IN") return "IN";

  const pathname = String(path).split("?")[0];
  return pathname.startsWith("/in") ? "IN" : "UAE";
}

export function getCountryFromContext(context = {}) {
  const resolved = context.resolvedUrl || context.req?.url || "";
  return resolveCountry(resolved, context.req);
}

export function getCountryFromRequest(req) {
  return resolveCountry(req?.url || "", req);
}
